import { render, staticRenderFns } from "./main-columns.vue?vue&type=template&id=74c518e0&"
import script from "./main-columns.vue?vue&type=script&lang=js&"
export * from "./main-columns.vue?vue&type=script&lang=js&"
import style0 from "./main-columns.vue?vue&type=style&index=0&id=74c518e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports